/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { ISpacerViewProps } from '@msdyn365-commerce-modules/spacer/src/modules/spacer/./spacer';
// VSI Customization - Start - Imports
import { addThrottledEvent, Node } from '@msdyn365-commerce-modules/utilities';
import MsDyn365, { ICoreContext } from '@msdyn365-commerce/core';
import classnames from 'classnames';
import * as React from 'react';
import _getViewPort from '../../../Utilities/get-view-port';
import { ISpacerProps } from '../definition-extensions/spacer.ext.props.autogenerated';
// VSI Customization - Ends
const SpacerView: React.FC<ISpacerViewProps & ISpacerProps<{}>> = props => {
    // VSI Customization - Start
    const { context, config } = props;
    const { className, spacerHeightMobile, spacerHeightTablet, spacerHeightDesktop } = config;
    const [isMobile, setisMobile] = React.useState<boolean>(false);
    const [isTablet, setisTablet] = React.useState<boolean>(false);
    const mfrmSpacerHeight = isMobile ? spacerHeightMobile : (isTablet ? spacerHeightTablet : spacerHeightDesktop) || null;
    const mfrmSpacerClass = mfrmSpacerHeight ? `ms-${mfrmSpacerHeight}` : 'ms-spacer';
    const mfrmClassName = (className && classnames(mfrmSpacerClass, className)) || mfrmSpacerClass;

    React.useEffect(() => {
        MsDyn365.isBrowser && addThrottledEvent(window, 'resize', () => updateViewPort(context, setisMobile, setisTablet));
        updateViewPort(context, setisMobile, setisTablet);
    });

    return <Node className={mfrmClassName} id={props.id} {...props.renderModuleAttributes(props)} />;
};

// Method for getting and updating viewport
const updateViewPort = (
    context: ICoreContext,
    setIsMobile: React.Dispatch<React.SetStateAction<boolean>>,
    setIsTablet: React.Dispatch<React.SetStateAction<boolean>>
): void => {
    const viewport = _getViewPort(context);

    if (viewport === 'xs' || viewport === 'sm') {
        setIsMobile(true);
        setIsTablet(false);
    } else if (viewport === 'md' || viewport === 'lg') {
        setIsMobile(false);
        setIsTablet(true);
    } else {
        setIsMobile(false);
        setIsTablet(false);
    }
};
// VSI Customization - Ends
export default SpacerView;
